module.exports = __webpack_public_path__ + "static/media/losestar.3aa3f6c3.png";